
import { Options, setup, mixins } from "vue-class-component";
import { RoutingUtilityMixin, AlbumAndAssetManagementMixin } from "@/mixins";
import HomeComponentHeader from "./HomeComponentHeader/index.vue";
import HomeComponentAssetFilterAndDisplay from "./HomeComponentAssetFilterAndDisplay/index.vue";
import HomeComponentSlider from "./HomeComponentSlider/index.vue";
import HomeComponentFooter from "./HomeComponentFooter/index.vue";
import { useMeta } from "vue-meta";
import { useMq } from "vue3-mq";
import { usersModule, assetsModule } from "@/store";

import { normalizeLangFromRoute } from "@/utils/locale";
import { loadLocaleData } from "@/utils/localeDataLoader";

@Options({
  name: "Home",
  components: {
    HomeComponentSlider,
    HomeComponentHeader,
    HomeComponentAssetFilterAndDisplay,
    HomeComponentFooter,
  },
  watch: {
    "$route.params.locale": {
      handler: "onLocaleChanged",
      immediate: false,
    },
  },
})
export default class Home extends mixins(
  RoutingUtilityMixin,
  AlbumAndAssetManagementMixin
) {
  private isLoadingLocaleData = false;
  protected isReadMoreExpand = false;
  protected mq = useMq();
  protected meta = setup(() =>
    useMeta({
      title: "3D Reference Tool",
      description:
        "Explore our 3D Reference tool extensive library of 3D models, images, and videos! A useful and convenient way to always have the right reference.",
      og: {
        title: "3D Reference Tool",
        description:
          "Explore our 3D Reference tool extensive library of 3D models, images, and videos! A useful and convenient way to always have the right reference.",
      },
    })
  );

  private resetAssets(): void {
    this.emitter.emit("drawer-open", null);
  }

  private resetTools(): void {
    this.resetAssets();
  }

  private get isAuthenticated(): boolean {
    return usersModule.IsAuthenticated;
  }

  protected async onLocaleChanged(
    newLocale: string,
    oldLocale: string
  ): Promise<void> {
    if (newLocale !== oldLocale && !this.isLoadingLocaleData) {
      await loadLocaleData(newLocale || "en");
    }
  }

  async created(): Promise<void> {
    const lang = normalizeLangFromRoute(this.$route);
    await loadLocaleData(lang);

    if (this.isAuthenticated) {
      await usersModule.WpUserAuthenticationToken();
      await assetsModule.LoadPinnedAssets(lang);
    }
  }

  mounted(): void {
    this.emitter.on("toggle-mobile-menu", (state: boolean) => {
      if (state) this.resetTools();
    });

    this.emitter.on("asset-description-toggle", (state: boolean) => {
      this.isReadMoreExpand = state;

      if (state) {
        setTimeout(
          () => window.scrollTo({ top: 200, behavior: "smooth" }),
          300
        );
      }
    });
  }
}
